import { Icon } from "../../../../../../components";

type Props = {
  "data-testid": string;
  onClick?: () => void;
};

const CloseIcon = ({ "data-testid": dataTestId, onClick }: Props) => (
  <Icon
    data-testid={dataTestId}
    style={{ cursor: "pointer" }}
    name="close"
    onClick={onClick}
  />
);

export default CloseIcon;
